import PropTypes from 'prop-types'
import { Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel } from "@mui/material"
import { useEffect, useState } from "react"
import { Controller, useFormContext } from "react-hook-form"

const CheckboxMultiple = ({
  control,
  label,
  name,
  options,
  raw = false
}) => {

  const { setValue, watch } = useFormContext()
  const selectedItems = watch(name) || []

  const handleSelect = (value) => {
    const isPresent = selectedItems.indexOf(value)
    if (isPresent !== -1) {
      const remaining = selectedItems.filter(item => item !== value)
      setValue(name, remaining)
    } else {
      setValue(name, [...selectedItems, value])
    }
  }

  return (
    <Controller
      control={control}
      name={name}
      render={({
        fieldState: { error }
      }) => (
        <FormControl error={!!error}>
          <FormLabel error={!!error}>{label}</FormLabel>
          <div>
            {options.map((option) => {
              return (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedItems.includes(option.value)}
                      onChange={() => handleSelect(option.value)}
                      size="small"
                    />
                  }
                  key={option.value}
                  label={option.label}
                  sx={raw ? { display: 'block' } : {}}
                />
              )
            })}
          </div>
          <FormHelperText>{error !== undefined ? error.message : ''}</FormHelperText>
        </FormControl>
      )}
    />
  )
}

CheckboxMultiple.propTypes = {
  control: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  raw: PropTypes.bool
}

export default CheckboxMultiple
